import { Box, useTheme } from "@mui/material";
import ReachImageList from "../homeSection/reach/reachImageList";
import TitleComponent from '../../components/widgets/titleComponent';
import { useTranslation } from "react-i18next";

const TechStackList = ({list}) => {
    const theme = useTheme();
    const {t} = useTranslation();

    return (
        <>
            <Box 
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default
                }}
            >
                <TitleComponent 
                    title={t('services.techStacks.title')}
                    description={t('services.techStacks.description')}
                    centerMode
                />

                <ReachImageList list={list}/>
            </Box>
        </>
    );
}

export default TechStackList;